module.exports = __webpack_public_path__ + "img/walkthrough_illust29@2x.7c519c6b.png";